import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { SessionType } from "@/api/sessionApi";
import seshPromo from "@/assets/sesh-promo-new.png";
interface DonationBannerProps {
  isVisible: boolean;
  onClose: () => void;
  sessionId: string | null;
  sessionType: SessionType;
}
export const DonationBanner = ({
  isVisible,
  onClose,
  sessionId,
  sessionType
}: DonationBannerProps) => {
  if (!isVisible) return null;
  const getStripeLink = () => {
    switch (sessionType) {
      case "stem":
        return "https://buy.stripe.com/4gM6oB3InbGd1PB2ZJfAc05";
      case "acapella":
        return "https://buy.stripe.com/bJe8wJ1Af11z0LxasbfAc06";
      case "drum":
        return "https://buy.stripe.com/7sYcMZdiXh0x79VgQzfAc07";
      default:
        return "";
    }
  };
  const handleTryForFree = () => {
    // PostHog tracking disabled
    // if (window.posthog) {
    //   window.posthog.capture("Sesh CTA Clicked", {
    //     session_id: sessionId,
    //     session_type: sessionType
    //   });
    // }
    window.open("https://sesh.fm", "_blank");
    onClose();
  };
  const handleMaybeLater = () => {
    // PostHog tracking disabled
    // if (window.posthog) {
    //   window.posthog.capture("Sesh Banner Dismissed", {
    //     session_id: sessionId,
    //     session_type: sessionType
    //   });
    // }
    onClose();
  };

  // PostHog tracking disabled
  // if (window.posthog && sessionId) {
  //   window.posthog.capture("Sesh Banner Shown", {
  //     session_id: sessionId,
  //     session_type: sessionType
  //   });
  // }
  return <TooltipProvider delayDuration={0}>
      <div className="w-full bg-card border border-border rounded-lg p-4 mb-4 animate-in slide-in-from-top duration-300">
        <div className="flex flex-col md:flex-row items-center gap-4 relative">
          {/* Close button */}
          <Tooltip>
            <TooltipTrigger asChild>
              <button onClick={handleMaybeLater} className="absolute top-0 right-0 p-1 hover:bg-muted rounded-full transition-colors" aria-label="Close banner">
                <X className="h-4 w-4" />
              </button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Close banner</p>
            </TooltipContent>
          </Tooltip>

          {/* Image */}
          <div className="relative w-full md:relative max-w-[100px] flex-shrink-0 overflow-hidden">
            <img src={seshPromo} alt="Sesh multiplayer DAW" className="w-full h-full object-cover rounded-md" />
          </div>

          {/* Text */}
          <div className="flex-1 text-center md:text-left">
            <h3 className="text-lg font-semibold mb-1">Try Sesh's multiplayer DAW</h3>
            <p className="text-sm text-muted-foreground">Join 200,000 music makers around the world.</p>
          </div>

          {/* Buttons */}
          <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto md:flex-shrink-0">
            <Tooltip>
              <TooltipTrigger asChild>
                <Button variant="default" className="bg-[#3B82F6] hover:bg-[#60A5FA] text-white w-full md:w-auto" onClick={handleTryForFree}>
                  Try for free
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>Check out Sesh</p>
              </TooltipContent>
            </Tooltip>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button variant="outline" className="w-full md:w-auto" onClick={handleMaybeLater}>
                  Maybe later
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>Dismiss banner</p>
              </TooltipContent>
            </Tooltip>
          </div>
        </div>
      </div>
    </TooltipProvider>;
};